export default __webpack_public_path__ + "static/media/Balthus's Buckskin Jerkin.678965ef.jpg";